export default {
    DEFAULT: 'ENGLISH',
    ENGLISH: {
        BACK: 'BACK',
        RESTART: 'RESTART',
        SKIP: 'SKIP'
    },
    SPANISH: {
        BACK: 'Atrás',
        RESTART: 'Reiniciar',
        SKIP: 'Omitir'
    },
    FRENCH: {
        BACK: 'Retour',
        RESTART: 'Recommencer',
        SKIP: 'Passer'
    },
  }